/**
 * Questionnaire v2 — Étapes 5, 6, 7 et 8
 * Demoiselles, vin d'honneur, centres de table, presque fini
 */
(function () {
  'use strict';

  let demoisellesChoice = null;
  let demoisellesQuantity = 0;
  let selectedElements = [];
  let selectedDecoration = null;
  let tablesQuantity = 0;
  let decorationGallery = null;

  function getUncroppedImageUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;
    let url = rawUrl.trim().replace(/&amp;/g, '&');
    url = url.replace(/_\d+x\d+_crop_center(?=\.)/i, '');
    url = url.replace(/_crop_center(?=\.)/i, '');
    url = url.replace(/_\d+x\d+(?=\.)/i, '');
    url = url.replace(/_\d+x(?=\.)/i, '');
    url = url.replace(/_x\d+(?=\.)/i, '');
    url = url.replace(/([?&])width=\d+(&|$)/i, '$1');
    url = url.replace(/([?&])height=\d+(&|$)/i, '$1');
    url = url.replace(/([?&])crop=[^&]*(&|$)/i, '$1');
    url = url.replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/, '');
    return url;
  }

  function setValidationButtonState(button, disabled) {
    if (button) button.disabled = disabled;
  }

  function setupNumericInputValidation(input, errorElement, maxLength, onValidationChange) {
    if (!input) return;

    const errorMessage = 'Le nombre ne peut pas dépasser ' + maxLength + ' chiffres.';

    function showError() {
      if (errorElement) {
        errorElement.style.display = 'block';
        errorElement.textContent = errorMessage;
      }
    }

    function hideError() {
      if (errorElement) errorElement.style.display = 'none';
    }

    function processValue(value) {
      const numbers = value.replace(/[^0-9]/g, '');
      if (numbers.length > maxLength) {
        showError();
        return numbers.slice(0, maxLength);
      }
      hideError();
      return numbers;
    }

    if (input.dataset.qv2NumericBound) return;
    input.dataset.qv2NumericBound = '1';

    input.addEventListener('input', function () {
      this.value = processValue(this.value);
      if (onValidationChange) onValidationChange();
    });
    input.addEventListener('blur', function () {
      this.value = processValue(this.value);
      if (onValidationChange) onValidationChange();
    });
    input.addEventListener('paste', function (e) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData).getData('text');
      this.value = processValue(pasted);
      if (onValidationChange) onValidationChange();
    });
  }

  function setupNoOptionButton(noButton, itemsSelector, onToggle, onValidation) {
    if (!noButton || noButton.dataset.qv2NoBound) return;
    noButton.dataset.qv2NoBound = '1';

    noButton.addEventListener('click', function () {
      this.classList.toggle('selected');
      if (this.classList.contains('selected')) {
        document.querySelectorAll(itemsSelector).forEach(function (item) {
          item.classList.remove('selected');
        });
      }
      if (onToggle) onToggle(this.classList.contains('selected'));
      if (onValidation) onValidation();
    });
  }

  class ImageGalleryModal {
    constructor(config) {
      this.modal = document.getElementById(config.modalId);
      this.modalImage = document.getElementById(config.imageId);
      this.modalCounter = document.getElementById(config.counterId);
      this.modalTitle = document.getElementById(config.titleId);
      this.modalPrev = document.getElementById(config.prevId);
      this.modalNext = document.getElementById(config.nextId);
      this.modalClose = document.getElementById(config.closeId);
      this.modalOverlay = this.modal ? this.modal.querySelector('.modal-overlay') : null;
      this.modalSelectBtn = document.getElementById(config.selectBtnId);
      this.onSelect = config.onSelect || null;
      this.images = [];
      this.currentIndex = 0;
      this.currentTitle = '';
      this.currentElement = null;
      this.minSwipeDistance = 50;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
      this.init();
    }

    init() {
      if (this.modalPrev) this.modalPrev.addEventListener('click', () => this.goToPrevious());
      if (this.modalNext) this.modalNext.addEventListener('click', () => this.goToNext());
      if (this.modalClose) this.modalClose.addEventListener('click', () => this.close());
      if (this.modalOverlay) this.modalOverlay.addEventListener('click', () => this.close());
      if (this.modalSelectBtn) this.modalSelectBtn.addEventListener('click', () => this.handleSelect());

      if (this.modalImage) {
        this.modalImage.addEventListener('dblclick', () => this.handleSelect());
        this.modalImage.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });
        this.modalImage.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.touchEndY = e.changedTouches[0].screenY;
          const deltaX = this.touchEndX - this.touchStartX;
          const deltaY = this.touchEndY - this.touchStartY;
          if (Math.abs(deltaX) > this.minSwipeDistance && Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX > 0) this.goToPrevious();
            else this.goToNext();
          }
        }, { passive: true });
      }

      if (!document.body.dataset.qv2DecorationGalleryEsc) {
        document.body.dataset.qv2DecorationGalleryEsc = '1';
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal && this.modal.classList.contains('active')) {
            this.close();
          }
        });
      }
    }

    open(item, imagesData, title, imageCount) {
      if (!imagesData || imagesData === '' || imageCount === 0) return false;
      this.images = imagesData.split('|||');
      this.currentIndex = 0;
      this.currentTitle = title;
      this.currentElement = item;
      this.loadImage(this.images[0], 1, this.images.length);
      if (this.modal) {
        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
      return true;
    }

    loadImage(imageUrl, index, total) {
      if (this.modalImage) this.modalImage.src = getUncroppedImageUrl(imageUrl);
      if (this.modalCounter) this.modalCounter.textContent = index + ' / ' + total;
      if (this.modalTitle) this.modalTitle.textContent = this.currentTitle;
      if (this.modalPrev) this.modalPrev.disabled = index === 1;
      if (this.modalNext) this.modalNext.disabled = index === total;
    }

    goToPrevious() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.loadImage(this.images[this.currentIndex], this.currentIndex + 1, this.images.length);
      }
    }

    goToNext() {
      if (this.currentIndex < this.images.length - 1) {
        this.currentIndex++;
        this.loadImage(this.images[this.currentIndex], this.currentIndex + 1, this.images.length);
      }
    }

    close() {
      if (this.modal) {
        this.modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    handleSelect() {
      if (this.currentElement && this.onSelect) {
        this.onSelect(this.currentElement);
        this.close();
      }
    }
  }

  function syncStep5StateFromDom() {
    const yesOption = document.getElementById('yes-option');
    const noOption = document.getElementById('no-option');
    const quantityInput = document.getElementById('demoiselles-quantity');

    if (yesOption && yesOption.classList.contains('selected')) {
      demoisellesChoice = 'yes';
    } else if (noOption && noOption.classList.contains('selected')) {
      demoisellesChoice = 'no';
    } else {
      demoisellesChoice = null;
    }

    if (quantityInput) {
      demoisellesQuantity = parseInt(quantityInput.value, 10) || 0;
    }
  }

  function initStep5() {
    const yesOption = document.getElementById('yes-option');
    const noOption = document.getElementById('no-option');
    const quantityInput = document.getElementById('demoiselles-quantity');
    const quantityMinus = document.getElementById('quantity-minus');
    const quantityPlus = document.getElementById('quantity-plus');
    const validateStep5 = document.getElementById('validate-step-5');

    if (!yesOption || !noOption || !quantityInput || !quantityMinus || !quantityPlus || !validateStep5) {
      return;
    }

    syncStep5StateFromDom();

    if (!quantityInput.dataset.qv2Step5Init) {
      quantityInput.dataset.qv2Step5Init = '1';
      quantityInput.readOnly = true;
      quantityInput.disabled = true;
      quantityMinus.disabled = true;
      quantityPlus.disabled = false;
    }

    function clearStep5Selection() {
      demoisellesChoice = null;
      yesOption.classList.remove('selected');
      noOption.classList.remove('selected');
      quantityInput.value = 0;
      demoisellesQuantity = 0;
      quantityInput.readOnly = true;
      quantityInput.disabled = true;
      quantityMinus.disabled = true;
      quantityPlus.disabled = false;
      setValidationButtonState(validateStep5, true);
    }

    function activateYesOption() {
      demoisellesChoice = 'yes';
      yesOption.classList.add('selected');
      noOption.classList.remove('selected');
      quantityInput.readOnly = false;
      quantityInput.disabled = false;
      quantityMinus.disabled = false;
      quantityPlus.disabled = false;
      setValidationButtonState(validateStep5, false);
    }

    if (!yesOption.dataset.qv2Bound) {
      yesOption.dataset.qv2Bound = '1';
      yesOption.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn')) return;
        if (yesOption.classList.contains('selected')) {
          clearStep5Selection();
          return;
        }
        activateYesOption();
        if (demoisellesQuantity === 0) {
          quantityInput.value = 1;
          demoisellesQuantity = 1;
        }
      });
    }

    if (!noOption.dataset.qv2Bound) {
      noOption.dataset.qv2Bound = '1';
      noOption.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn')) return;
        if (noOption.classList.contains('selected')) {
          clearStep5Selection();
          return;
        }
        demoisellesChoice = 'no';
        noOption.classList.add('selected');
        yesOption.classList.remove('selected');
        quantityInput.value = 0;
        demoisellesQuantity = 0;
        quantityInput.readOnly = true;
        quantityInput.disabled = true;
        quantityMinus.disabled = true;
        quantityPlus.disabled = false;
        setValidationButtonState(validateStep5, false);
      });
    }

    if (!quantityMinus.dataset.qv2Bound) {
      quantityMinus.dataset.qv2Bound = '1';
      quantityMinus.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let currentValue = parseInt(quantityInput.value, 10) || 0;
        if (currentValue > 0) {
          currentValue--;
          quantityInput.value = currentValue;
          demoisellesQuantity = currentValue;
        }
      });
    }

    if (!quantityPlus.dataset.qv2Bound) {
      quantityPlus.dataset.qv2Bound = '1';
      quantityPlus.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (demoisellesChoice !== 'yes') {
          activateYesOption();
          quantityInput.value = 1;
          demoisellesQuantity = 1;
        } else {
          let currentValue = parseInt(quantityInput.value, 10) || 0;
          currentValue++;
          quantityInput.value = currentValue;
          demoisellesQuantity = currentValue;
        }
      });
    }

    if (!quantityInput.dataset.qv2InputBound) {
      quantityInput.dataset.qv2InputBound = '1';
      quantityInput.addEventListener('input', function () {
        let value = parseInt(this.value, 10) || 0;
        if (value < 0) value = 0;
        this.value = value;
        demoisellesQuantity = value;
      });
    }

    const quantitySection = document.querySelector('.questionnaire-step[data-step="5"] .yes-no-quantity-section');
    if (quantitySection && !quantitySection.dataset.qv2Bound) {
      quantitySection.dataset.qv2Bound = '1';
      quantitySection.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    const quantitySelector = document.querySelector('.questionnaire-step[data-step="5"] .quantity-selector');
    if (quantitySelector && !quantitySelector.dataset.qv2Bound) {
      quantitySelector.dataset.qv2Bound = '1';
      quantitySelector.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    if (!demoisellesChoice) {
      setValidationButtonState(validateStep5, true);
    }
  }

  function syncStep6StateFromDom() {
    selectedElements = [];
    document.querySelectorAll('.questionnaire-step[data-step="6"] .element-item.selected').forEach(function (item) {
      const elementId = item.getAttribute('data-element-id');
      if (elementId && !selectedElements.includes(elementId)) {
        selectedElements.push(elementId);
      }
    });
  }

  function updateStep6Validation() {
    const validateStep6 = document.getElementById('validate-step-6');
    const step6NoOption = document.getElementById('step6-no-option');
    if (validateStep6) {
      const noOptionSelected = step6NoOption && step6NoOption.classList.contains('selected');
      validateStep6.disabled = selectedElements.length === 0 && !noOptionSelected;
    }
  }

  function initStep6() {
    const step6NoOption = document.getElementById('step6-no-option');
    if (!document.querySelector('.questionnaire-step[data-step="6"] .element-item') && !step6NoOption) {
      return;
    }

    syncStep6StateFromDom();

    if (!document.body.dataset.qv2Step6Click) {
      document.body.dataset.qv2Step6Click = '1';
      document.addEventListener('click', function (e) {
        const step6 = document.querySelector('.questionnaire-step[data-step="6"]');
        if (!step6 || !step6.contains(e.target)) return;

        const elementItem = e.target.closest('.element-item');
        if (!elementItem || !step6.contains(elementItem)) return;

        const elementId = elementItem.getAttribute('data-element-id');
        const wasSelected = elementItem.classList.contains('selected');
        const noBtn = document.getElementById('step6-no-option');

        if (noBtn && noBtn.classList.contains('selected')) {
          noBtn.classList.remove('selected');
        }

        if (wasSelected) {
          elementItem.classList.remove('selected');
          selectedElements = selectedElements.filter(function (id) { return id !== elementId; });
        } else {
          elementItem.classList.add('selected');
          if (elementId && !selectedElements.includes(elementId)) {
            selectedElements.push(elementId);
          }
        }

        updateStep6Validation();
      });
    }

    if (step6NoOption && !step6NoOption.dataset.qv2Bound) {
      step6NoOption.dataset.qv2Bound = '1';
      step6NoOption.addEventListener('click', function () {
        document.querySelectorAll('.questionnaire-step[data-step="6"] .element-item').forEach(function (item) {
          item.classList.remove('selected');
        });
        selectedElements = [];
        this.classList.toggle('selected');
        updateStep6Validation();
      });
    }

    updateStep6Validation();
  }

  function syncStep7StateFromDom() {
    const tablesInput = document.getElementById('tables-quantity');
    const selectedItem = document.querySelector('.questionnaire-step[data-step="7"] .decoration-item.selected');

    selectedDecoration = selectedItem ? selectedItem.getAttribute('data-decoration-id') : null;
    tablesQuantity = tablesInput ? (parseInt(tablesInput.value, 10) || 0) : 0;
  }

  function initStep7() {
    const validateStep7 = document.getElementById('validate-step-7');
    const noDecorationBtn = document.getElementById('step7-no-option');
    const tablesInput = document.getElementById('tables-quantity');
    const tablesError = document.getElementById('tables-error');
    const tablesHelpLink = document.getElementById('tables-help-link');
    const tablesHelpModal = document.getElementById('tables-help-modal');
    const tablesHelpClose = document.getElementById('tables-help-close');
    const step7El = document.querySelector('.questionnaire-step[data-step="7"]');

    if (!step7El) return;

    syncStep7StateFromDom();

    function updateStep7Validation() {
      if (!validateStep7) return;

      const noDecorationSelected = noDecorationBtn && noDecorationBtn.classList.contains('selected');
      const decorationSelected = selectedDecoration !== null;

      if (noDecorationSelected) {
        validateStep7.disabled = false;
      } else if (decorationSelected) {
        validateStep7.disabled = tablesQuantity <= 0;
      } else {
        validateStep7.disabled = true;
      }
    }

    function updateTablesQuantity() {
      tablesQuantity = tablesInput ? (parseInt(tablesInput.value, 10) || 0) : 0;
      updateStep7Validation();
    }

    if (tablesInput) {
      setupNumericInputValidation(tablesInput, tablesError, 3, updateTablesQuantity);
      updateTablesQuantity();
    }

    function selectDecoration(item) {
      if (!item) return;

      if (noDecorationBtn && noDecorationBtn.classList.contains('selected')) {
        noDecorationBtn.classList.remove('selected');
        step7El.classList.remove('step7-no-decoration-active');
        if (tablesInput) {
          tablesInput.disabled = false;
          tablesInput.style.opacity = '1';
          tablesInput.style.cursor = 'text';
        }
      }

      document.querySelectorAll('.questionnaire-step[data-step="7"] .decoration-item').forEach(function (i) {
        if (i !== item) i.classList.remove('selected');
      });

      item.classList.add('selected');
      selectedDecoration = item.getAttribute('data-decoration-id');
      updateStep7Validation();
    }

    function openDecorationGallery(decorationItem, options) {
      options = options || {};
      if (!decorationGallery) {
        if (!options.zoomOnly) selectDecoration(decorationItem);
        return false;
      }
      const imagesData = decorationItem.getAttribute('data-decoration-images');
      const decorationTitle = decorationItem.getAttribute('data-decoration-title');
      const imageCount = parseInt(decorationItem.getAttribute('data-image-count'), 10) || 0;

      if (decorationGallery.open(decorationItem, imagesData, decorationTitle, imageCount)) {
        return true;
      }
      if (!options.zoomOnly) selectDecoration(decorationItem);
      return false;
    }

    function openDecorationZoom(decorationItem, zoomBtn) {
      if (window.QV2 && typeof window.QV2.ensureSharedUiInBody === 'function') {
        window.QV2.ensureSharedUiInBody();
      }
      if (openDecorationGallery(decorationItem, { zoomOnly: true })) return;
      const src = (window.QV2 && window.QV2.resolveZoomImageSrc)
        ? window.QV2.resolveZoomImageSrc(zoomBtn)
        : (zoomBtn.getAttribute('data-lightbox-src') || '');
      if (src && window.QV2 && typeof window.QV2.openImageLightbox === 'function') {
        window.QV2.openImageLightbox(src);
      }
    }

    if (window.QV2 && typeof window.QV2.ensureSharedUiInBody === 'function') {
      window.QV2.ensureSharedUiInBody();
    }
    if (!decorationGallery && document.getElementById('decoration-gallery-modal')) {
      decorationGallery = new ImageGalleryModal({
        modalId: 'decoration-gallery-modal',
        imageId: 'decoration-modal-image',
        counterId: 'decoration-modal-counter',
        titleId: 'decoration-modal-title',
        prevId: 'decoration-modal-prev',
        nextId: 'decoration-modal-next',
        closeId: 'decoration-modal-close',
        selectBtnId: 'decoration-modal-select-btn',
        onSelect: selectDecoration
      });
    }

    document.querySelectorAll('.questionnaire-step[data-step="7"] .decoration-item').forEach(function (item) {
      if (item.dataset.qv2DecorationBound) return;
      item.dataset.qv2DecorationBound = '1';

      item.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn')) {
          e.stopPropagation();
          return;
        }

        selectDecoration(this);

        const imagesData = this.getAttribute('data-decoration-images');
        if (imagesData && imagesData.trim() !== '') {
          openDecorationGallery(this);
        }
      });
    });

    if (!document.body.dataset.qv2DecorationZoomClick) {
      document.body.dataset.qv2DecorationZoomClick = '1';
      document.addEventListener('click', function (e) {
        const zoomBtn = e.target.closest('.questionnaire-step[data-step="7"] .decoration-item .image-zoom-btn');
        if (!zoomBtn) return;
        e.preventDefault();
        e.stopPropagation();
        const decorationItem = zoomBtn.closest('.decoration-item');
        if (decorationItem) openDecorationZoom(decorationItem, zoomBtn);
      }, true);
    }

    setupNoOptionButton(
      noDecorationBtn,
      '.questionnaire-step[data-step="7"] .decoration-item',
      function (isActive) {
        if (isActive) {
          step7El.classList.add('step7-no-decoration-active');
          selectedDecoration = null;
          if (tablesInput) {
            tablesInput.value = '';
            tablesQuantity = 0;
            tablesInput.disabled = true;
            tablesInput.style.opacity = '0.25';
            tablesInput.style.cursor = 'not-allowed';
            if (tablesError) tablesError.style.display = 'none';
          }
        } else {
          step7El.classList.remove('step7-no-decoration-active');
          if (tablesInput) {
            tablesInput.disabled = false;
            tablesInput.style.opacity = '1';
            tablesInput.style.cursor = 'text';
          }
        }
      },
      updateStep7Validation
    );

    function openTablesHelpModal() {
      if (!tablesHelpModal) return;

      const invitesInput = document.getElementById('nombre-invites');
      const invitesInputValue = invitesInput ? invitesInput.value : '0';
      const invitesCount = parseInt(invitesInputValue, 10) || 0;
      const calculatedTables = Math.ceil(invitesCount / 6);

      const modalInvitesCount = document.getElementById('modal-invites-count');
      const modalTablesResult = document.getElementById('modal-tables-result');
      const modalAutofillHint = document.getElementById('modal-tables-autofill-hint');

      if (modalInvitesCount) {
        modalInvitesCount.textContent = invitesCount + ' invités';
      }
      if (modalTablesResult) {
        modalTablesResult.textContent = calculatedTables + ' tables';
      }
      if (modalAutofillHint) {
        modalAutofillHint.hidden = false;
        if (calculatedTables > 0) {
          modalAutofillHint.textContent =
            'Ce nombre a été saisi automatiquement dans le champ sous la question (nombre de tables). Vous pouvez le modifier si besoin.';
        } else {
          modalAutofillHint.textContent =
            'Indiquez d’abord le nombre d’invités à l’étape 3 pour obtenir une estimation, puis saisissez le nombre de tables dans le champ prévu.';
        }
      }

      if (tablesInput && !tablesInput.disabled && calculatedTables > 0) {
        tablesInput.value = String(calculatedTables);
        tablesInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      tablesHelpModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeTablesHelpModal() {
      if (tablesHelpModal) {
        tablesHelpModal.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    if (tablesHelpLink && !tablesHelpLink.dataset.qv2Bound) {
      tablesHelpLink.dataset.qv2Bound = '1';
      tablesHelpLink.addEventListener('click', function (e) {
        e.preventDefault();
        openTablesHelpModal();
      });
    }

    if (tablesHelpClose && !tablesHelpClose.dataset.qv2Bound) {
      tablesHelpClose.dataset.qv2Bound = '1';
      tablesHelpClose.addEventListener('click', closeTablesHelpModal);
    }

    if (tablesHelpModal && !tablesHelpModal.dataset.qv2Bound) {
      tablesHelpModal.dataset.qv2Bound = '1';
      const modalOverlay = tablesHelpModal.querySelector('.modal-overlay');
      if (modalOverlay) {
        modalOverlay.addEventListener('click', closeTablesHelpModal);
      }
    }

    if (!document.body.dataset.qv2TablesHelpEsc) {
      document.body.dataset.qv2TablesHelpEsc = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && tablesHelpModal && tablesHelpModal.classList.contains('active')) {
          closeTablesHelpModal();
        }
      });
    }

    updateStep7Validation();
  }

  function initStep8() {
    // Étape 8 : pas de logique JS spéciale — le bouton VALIDER reste toujours actif
  }

  function initSteps0508() {
    if (!document.querySelector('[data-qv2-section="05-08"]')) return;
    initStep5();
    initStep6();
    initStep7();
    initStep8();
  }

  function onStepShown(stepNumber) {
    if (stepNumber >= 5 && stepNumber <= 8) {
      initSteps0508();
    }
  }

  window.QV2_STEPS_05_08 = {
    init: initSteps0508,
    onStepShown: onStepShown,
    getState: function () {
      return {
        demoisellesChoice: demoisellesChoice,
        demoisellesQuantity: demoisellesQuantity,
        tablesQuantity: tablesQuantity
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSteps0508);
  } else {
    initSteps0508();
  }
})();
